import { createRouter, createWebHashHistory } from 'vue-router';
const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: () => import('@/components/Login.vue') },
  {
    path: '/home',
    component: () => import('@/components/Home/Home.vue'),
    // redirect: '/search',
    children: [
      {
        path: '/search',
        component: () => import('@/components/User/Search.vue')
      },
      {
        path: '/borrow',
        component: () => import('@/components/User/Borrow.vue')
      },
      {
        path: '/Violation',
        component: () => import('@/components/User/Violation.vue')
      },
      {
        path: '/enterpriseRecharge',
        component: () => import('@/components/User/enterpriseRecharge.vue')
      },
      {
        path: '/OpenreCords',
        component: () => import('@/components/User/OpenreCords.vue')
      },
      {
        path: '/rechargeRecord',
        component: () => import('@/components/User/rechargeRecord.vue')
      },
      {
        path: '/redeemCode',
        component: () => import('@/components/User/RedeemCode.vue')
      },
      {
        path: '/channelCode',
        component: () => import('@/components/User/ChannelCode.vue')
      },
      {
        path: '/imAccount',
        component: () => import('@/components/User/ImAccountList.vue')
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/components/404/404.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
